export const FULLWIDTH_ROUTES: RegExp[] = [
  /^\/$/,
  /^\/index$/,
  /^\/landing$/,
  /^\/storefront\//,
  /^\/auth$/,
  /^\/whiteboard\/public\//,
];

export const isFullwidthPath = (pathname: string) =>
  FULLWIDTH_ROUTES.some((re) => re.test(pathname));
